module.exports = __webpack_public_path__ + "49a2812e7bc3345b14b0b90071da29ff.svg";